import { render, staticRenderFns } from "./PolicyDetailList.vue?vue&type=template&id=f40ecf6c&scoped=true&"
import script from "./PolicyDetailList.vue?vue&type=script&lang=js&"
export * from "./PolicyDetailList.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDetailList.vue?vue&type=style&index=0&id=f40ecf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40ecf6c",
  null
  
)

export default component.exports